import React, { useState, useEffect, useRef } from "react";

// ─── SVITLO logo (чорний монограм; на темному фоні інвертуємо у біле через filter) ───
const SV_LOGO = "data:image/png;base64,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";

// ─── Design tokens (SVITLO / Spalah 360 — warm dark + orange + teal) ───
const C = {
  canvas: "#dfe0e2",
  card: "#111111",
  surface: "#1b1b1c",
  surface2: "#242426",
  surface3: "#2a2a2c",
  codebg: "#0a0a0a",
  line: "#323234",
  line2: "#3a3a3c",
  fg: "#f5f3f0",
  fg2: "#d4d1cd",
  fg3: "#b3b0ac",
  mute: "#9b9894",
  mute2: "#6f6c69",
  accent: "#ff6a2b",
  accentHi: "#ff8150",
  accentInk: "#140a05",
  pos: "#3df5c8",
  posInk: "#08201a",
  warn: "#ffd23f",
  neg: "#ff5a52",
};
const DISPLAY = "'Unbounded', ui-sans-serif, system-ui, sans-serif";
const SANS = "'Manrope', ui-sans-serif, system-ui, -apple-system, sans-serif";
const MONO = "'JetBrains Mono', ui-monospace, 'SF Mono', monospace";

const SV_SUFFIX_RE = /\s*👉\s*Якщо не знаєте як[\s\S]*$/u;

const fmt = (n) => Number(n || 0).toLocaleString("uk-UA");
const fmtf = (n, d = 2) => Number(n || 0).toLocaleString("uk-UA", { minimumFractionDigits: d, maximumFractionDigits: d });

function scoreColor(s) {
  if (s == null) return C.mute;
  if (s >= 80) return C.pos;
  if (s >= 55) return C.accent;
  if (s >= 35) return C.warn;
  return C.neg;
}
function statusLabel(s) {
  if (s == null) return "—";
  if (s >= 90) return "Чудово";
  if (s >= 75) return "Добре";
  if (s >= 60) return "Прийнятно";
  if (s >= 40) return "Слабко";
  return "Критично";
}
function psiColor(v) {
  return v >= 90 ? C.pos : v >= 50 ? C.accent : C.warn;
}

function useAssets() {
  useEffect(() => {
    if (!document.getElementById("r360-fonts")) {
      const pre1 = document.createElement("link"); pre1.rel = "preconnect"; pre1.href = "https://fonts.googleapis.com"; document.head.appendChild(pre1);
      const pre2 = document.createElement("link"); pre2.rel = "preconnect"; pre2.href = "https://fonts.gstatic.com"; pre2.crossOrigin = "anonymous"; document.head.appendChild(pre2);
      const link = document.createElement("link"); link.id = "r360-fonts"; link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Unbounded:wght@500;600;700&family=Manrope:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap";
      document.head.appendChild(link);
    }
    if (!document.getElementById("r360-tokens")) {
      const s = document.createElement("style");
      s.id = "r360-tokens";
      s.textContent = `
        @keyframes r360-rise { from { opacity:0; transform: translateY(24px);} to { opacity:1; transform:none;} }
        @keyframes r360-drop { from { opacity:0; transform: translateY(-6px);} to { opacity:1; transform:none;} }
        @keyframes r360-pulse { 0%,100%{ opacity:1; transform:scale(1);} 50%{ opacity:.35; transform:scale(.7);} }
        @keyframes r360-spin { to { transform: rotate(360deg);} }
        @media (prefers-reduced-motion: reduce) { *,*::before,*::after { animation:none !important; transition:none !important; } }
        .r360-wrap { max-width: none; margin: 0; padding: 0; }
        .r360-card { background:${C.card}; color:${C.fg}; border-radius:0; overflow:hidden; padding:28px clamp(16px,4vw,72px) 60px; position:relative; min-height:100vh; }
        .r360-hero { display:grid; grid-template-columns: minmax(0,7fr) minmax(0,5fr); gap:48px; margin-top:56px; align-items:stretch; }
        .r360-aip { display:grid; grid-template-columns: minmax(0,5fr) minmax(0,7fr); gap:48px; margin-top:16px; }
        .r360-cats { display:grid; grid-template-columns: repeat(auto-fit, minmax(150px,1fr)); gap:10px; margin-top:24px; }
        .r360-chartrow { display:grid; grid-template-columns: minmax(0,8fr) minmax(0,4fr); gap:16px; margin-top:16px; }
        .r360-serp7 { display:grid; grid-template-columns: repeat(auto-fit, minmax(130px,1fr)); gap:10px; margin-top:20px; }
        .r360-serp-wrap { padding:28px; }
        .r360-serp-v { font-size:20px; }
        .r360-distrow { display:grid; grid-template-columns: minmax(0,4fr) minmax(0,8fr); gap:16px; margin-top:16px; align-items:start; }
        .r360-split { display:grid; grid-template-columns: minmax(0,4fr) minmax(0,8fr); gap:48px; align-items:start; }
        .r360-wins { display:grid; grid-template-columns: 1fr 1fr; gap:8px; }
        .r360-cta { display:grid; grid-template-columns: minmax(0,7fr) minmax(0,5fr); gap:48px; align-items:center; }
        .r360-foot { display:flex; justify-content:space-between; gap:24px; margin-top:40px; font-size:13px; line-height:20px; color:${C.mute}; }
        .r360-mobbar { display:none; }
        .r360-krow td, .r360-krow { transition: background 0.12s; }
        .r360-irow:hover { background:${C.surface2}; }
        .r360-link:hover { color:${C.accentHi} !important; }
        @media (max-width: 920px) {
          .r360-wrap { padding:0; }
          .r360-card { padding:20px 16px 112px; border-radius:0; }
          .r360-hero,.r360-aip,.r360-chartrow,.r360-distrow,.r360-split,.r360-cta { grid-template-columns:1fr !important; gap:20px !important; }
          .r360-cats { grid-template-columns: repeat(2,1fr) !important; }
          .r360-wins { grid-template-columns:1fr !important; }
          .r360-hide-m { display:none !important; }
          .r360-h1 { font-size:34px !important; }
          .r360-score { font-size:96px !important; }
          .r360-mobbar { display:flex; position:fixed; left:12px; right:12px; bottom:12px; z-index:40; gap:6px; padding:6px; background:${C.surface}; border:1px solid ${C.line}; border-radius:18px; box-shadow:0 10px 40px rgba(0,0,0,.5); }
          .r360-serp7 { grid-template-columns: repeat(2,1fr) !important; gap:8px !important; margin-top:16px !important; }
          .r360-serp-wrap { padding:18px 14px !important; }
          .r360-serp-v { font-size:16px !important; }
        }
      `;
      document.head.appendChild(s);
    }
  }, []);
}

// ─── Brand mark: SVITLO logo (white on dark via filter) ───
function Logo({ h = 20 }) {
  return <img src={SV_LOGO} alt="SVITLO" style={{ height: h, width: "auto", display: "block", filter: "invert(1) brightness(2.2)" }} />;
}

// ─── Loading + error states ───
function Shell({ children }) {
  return <div style={{ minHeight: "100vh", background: C.card, fontFamily: SANS }}>{children}</div>;
}

export default function Spalah360Result({ token }) {
  useAssets();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const pollRef = useRef(null);

  useEffect(() => {
    document.title = "Spalah 360 — Ваш аудит";
    document.body.style.margin = "0";
    document.body.style.background = C.card;
    document.body.style.color = C.fg;
    document.body.style.fontFamily = SANS;
  }, []);

  useEffect(() => {
    if (!token) return;
    const fetchData = async () => {
      try {
        const r = await fetch(`/api/public/spalah360/${token}`);
        const d = await r.json();
        if (!r.ok) { setErr(d.error || "Помилка"); return; }
        setData(d);
        if (d.status === "done" || d.status === "error") {
          if (pollRef.current) clearInterval(pollRef.current);
        }
      } catch (e) { setErr(e.message); }
    };
    fetchData();
    pollRef.current = setInterval(fetchData, 2500);
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, [token]);

  if (!data || data.status === "pending" || data.status === "running") {
    return (
      <Shell>
        <div className="r360-wrap"><div className="r360-card" style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
          <div>
            <div style={{ width: 90, height: 90, margin: "0 auto 28px", borderRadius: "50%", border: `4px solid ${C.surface3}`, borderTopColor: C.accent, animation: "r360-spin 1s linear infinite" }} />
            <div style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 30, color: C.fg, letterSpacing: "-0.02em" }}>Аналізуємо ваш сайт</div>
            <div style={{ fontSize: 15, color: C.mute, marginTop: 10 }}>{data?.domain || "..."}</div>
            <div style={{ display: "inline-block", marginTop: 22, padding: "11px 18px", background: C.surface, border: `1px solid ${C.line}`, borderRadius: 12, fontSize: 14, color: C.fg2 }}>
              {data?.progress_message || "Запускаємо чеки..."}
            </div>
            <div style={{ marginTop: 26, fontSize: 12.5, color: C.mute2 }}>Це зазвичай займає 30–60 секунд. Сторінка оновиться сама.</div>
          </div>
        </div></div>
      </Shell>
    );
  }

  if (data.status === "error" || err) {
    return (
      <Shell>
        <div className="r360-wrap"><div className="r360-card" style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
          <div style={{ maxWidth: 460 }}>
            <div style={{ fontSize: 46, color: C.neg, marginBottom: 14 }}>⚠</div>
            <div style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 24, color: C.neg }}>Не вдалось завершити аудит</div>
            <div style={{ fontSize: 14.5, color: C.fg3, margin: "14px 0 24px", lineHeight: 1.5 }}>{data?.error || err}</div>
            <a href="/360" style={{ display: "inline-block", padding: "13px 26px", background: C.accent, color: C.accentInk, borderRadius: 13, fontWeight: 700, textDecoration: "none" }}>Спробувати з іншим доменом</a>
          </div>
        </div></div>
      </Shell>
    );
  }

  return <Report data={data} />;
}

const CATS = [
  { key: "aeo", label: "AEO · Готовність до AI" },
  { key: "technical", label: "Технічне SEO" },
  { key: "onpage", label: "On-page та контент" },
  { key: "schema", label: "Schema-розмітка" },
  { key: "eeat", label: "E-E-A-T сигнали" },
  { key: "authority", label: "Авторитет / трафік" },
  { key: "cwv", label: "Швидкодія · CWV" },
];
const CAT_LABEL = {
  technical: "Технічне SEO", aeo: "AEO", onpage: "On-page", schema: "Schema",
  eeat: "E-E-A-T", authority: "Авторитет", cwv: "Швидкодія", citability: "On-page",
};

function Report({ data }) {
  const findings = Array.isArray(data.findings) ? data.findings : [];
  const critical = findings.filter(f => f.severity === "critical");
  const warnings = findings.filter(f => f.severity === "warning");
  const wins = findings.filter(f => f.severity === "pass");
  const attention = [...critical, ...warnings];
  const overall = data.score_overall;
  const cleanDomain = (data.domain || "").replace(/^https?:\/\//, "").replace(/\/$/, "");
  const extras = data.metrics?.serpstat_extras || null;
  const history = Array.isArray(data.metrics?.serpstat_history) ? data.metrics.serpstat_history : [];
  const ps = data.metrics?.pagespeed || null;

  const total = findings.length;
  const barWin = wins.length || 0.001, barWarn = warnings.length || 0.001, barCrit = critical.length || 0.001;

  const [descOpen, setDescOpen] = useState(false);

  const cats = CATS.map(c => ({ ...c, v: data[`score_${c.key}`] })).filter(c => c.v != null);

  // Top-3 priorities: critical first, fill with warnings
  const top3 = attention.slice(0, 3).map((f, i) => ({
    n: i + 1, title: f.title,
    body: (f.description || "").replace(/\s+/g, " ").slice(0, 150) + ((f.description || "").length > 150 ? "…" : ""),
  }));

  return (
    <Shell>
      <div className="r360-wrap">
        <div className="r360-card">
          {/* Header */}
          <header style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <a href="/360" style={{ display: "flex", alignItems: "center", gap: 14, textDecoration: "none", color: C.fg }}>
              <Logo h={24} />
              <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontWeight: 800, fontSize: 18, letterSpacing: "-0.01em" }}>Spalah <span style={{ color: C.accent }}>360</span></span>
              </span>
              <span className="r360-hide-m" style={{ fontSize: 13, color: C.mute, paddingLeft: 12, borderLeft: `1px solid ${C.line}` }}>by Svitlo Agency</span>
            </a>
            <a href="/360" style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8, padding: "11px 18px", borderRadius: 12, background: C.surface, border: `1px solid ${C.line}`, fontWeight: 700, fontSize: 14, color: C.fg, textDecoration: "none" }}>← Новий аудит</a>
          </header>

          {/* Hero */}
          <div className="r360-hero">
            <div style={{ animation: "r360-rise 800ms cubic-bezier(.2,.7,.2,1) both" }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.12em", color: C.accent }}>АУДИТ САЙТУ</div>
              <h2 className="r360-h1" style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 64, lineHeight: 1.05, letterSpacing: "-0.03em", margin: "14px 0 0", overflowWrap: "anywhere" }}>{cleanDomain}</h2>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 22 }}>
                {[
                  data.finished_at ? new Date(data.finished_at).toLocaleDateString("uk-UA") : null,
                  data.homepage_lang ? `lang: ${data.homepage_lang}` : null,
                  `${total} перевірок`,
                ].filter(Boolean).map((m, i) => (
                  <span key={i} style={{ padding: "7px 12px", borderRadius: 999, background: C.surface, border: `1px solid ${C.line}`, font: `500 13px ${MONO}`, color: C.fg2 }}>{m}</span>
                ))}
              </div>
              {(data.homepage_title || data.homepage_description) && (
                <div style={{ marginTop: 28, padding: "20px 22px", background: C.surface, borderRadius: 18 }}>
                  {data.homepage_title && (<>
                    <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", color: C.mute }}>TITLE · {data.homepage_title.length} СИМВ.</div>
                    <div style={{ fontSize: 17, lineHeight: "25px", fontWeight: 600, marginTop: 8 }}>{data.homepage_title}</div>
                  </>)}
                  {data.homepage_description && (<>
                    <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", color: C.mute, marginTop: 18 }}>DESCRIPTION · {data.homepage_description.length} СИМВ.</div>
                    <p style={{ fontSize: 14.5, lineHeight: "22px", margin: "8px 0 0", color: C.fg3, ...(descOpen ? {} : { display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 2, overflow: "hidden" }) }}>{data.homepage_description}</p>
                    {data.homepage_description.length > 120 && (
                      <button onClick={() => setDescOpen(o => !o)} style={{ marginTop: 8, padding: 0, background: "none", border: 0, color: C.accent, font: `700 13px ${SANS}`, cursor: "pointer" }}>{descOpen ? "Згорнути" : "Показати повністю"}</button>
                    )}
                  </>)}
                </div>
              )}
            </div>

            {/* Score card */}
            <div style={{ animation: "r360-rise 900ms cubic-bezier(.2,.7,.2,1) 150ms both", padding: 28, background: C.surface, borderRadius: 26, display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", color: C.mute }}>ЗАГАЛЬНИЙ БАЛ</span>
                <span style={{ padding: "5px 12px", borderRadius: 999, background: scoreColor(overall), color: overall >= 80 ? C.posInk : C.accentInk, fontWeight: 800, fontSize: 13 }}>{statusLabel(overall)}</span>
              </div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginTop: 18 }}>
                <AnimatedNumber value={overall} className="r360-score" style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 140, lineHeight: 0.9, letterSpacing: "-0.05em", fontVariantNumeric: "tabular-nums" }} />
                <span style={{ fontSize: 20, color: C.mute }}>/100</span>
              </div>
              <div style={{ display: "flex", gap: 3, height: 8, marginTop: 24 }}>
                <span style={{ borderRadius: 4, background: C.pos, flexGrow: barWin }} />
                <span style={{ borderRadius: 4, background: C.accent, flexGrow: barWarn }} />
                <span style={{ borderRadius: 4, background: C.neg, flexGrow: barCrit }} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0,1fr))", gap: 12, marginTop: "auto", paddingTop: 28 }}>
                {[
                  { label: "Перемоги", v: wins.length, c: C.pos },
                  { label: "Уваги", v: warnings.length, c: C.accent },
                  { label: "Критичні", v: critical.length, c: C.neg },
                  { label: "Перевірок", v: total, c: C.mute },
                ].map((s, i) => (
                  <div key={i}>
                    <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12.5, color: C.mute }}><span style={{ width: 7, height: 7, borderRadius: "50%", background: s.c }} />{s.label}</div>
                    <div style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 32, lineHeight: 1, marginTop: 10, fontVariantNumeric: "tabular-nums" }}>{s.v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* AI + priorities */}
          {(data.ai_narrative || top3.length > 0) && (
            <div className="r360-aip" style={{ padding: 32, background: C.surface, borderRadius: 26, animation: "r360-rise 900ms cubic-bezier(.2,.7,.2,1) 250ms both" }}>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ width: 8, height: 8, borderRadius: "50%", background: C.accent, animation: "r360-pulse 1.6s ease-in-out infinite" }} /><span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", color: C.accent }}>AI-ВИСНОВОК</span></div>
                <AiNarrative text={data.ai_narrative} />
              </div>
              {top3.length > 0 && (
                <div>
                  <div style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 20 }}>Пріоритети для виправлення</div>
                  <div style={{ display: "grid", gap: 10, marginTop: 18 }}>
                    {top3.map((t, i) => (
                      <div key={i} style={{ display: "grid", gridTemplateColumns: "44px minmax(0,1fr)", gap: 14, padding: 18, background: C.surface2, borderRadius: 16 }}>
                        <span style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 26, lineHeight: 1, color: C.accent }}>{t.n}</span>
                        <div><div style={{ fontWeight: 700, fontSize: 16, lineHeight: "22px" }}>{t.title}</div><p style={{ margin: "6px 0 0", fontSize: 14.5, lineHeight: "22px", color: C.fg3 }}>{t.body}</p></div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Categories */}
          {cats.length > 0 && (
            <div style={{ marginTop: 80 }}>
              <h3 style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 32, lineHeight: 1.1, letterSpacing: "-0.02em", margin: 0 }}>Оцінки по категоріях</h3>
              <div className="r360-cats">
                {cats.map((c) => (
                  <div key={c.key} style={{ padding: 20, background: C.surface, borderRadius: 18, display: "flex", flexDirection: "column", minHeight: 176, boxSizing: "border-box" }}>
                    <div style={{ fontSize: 14, lineHeight: "19px", fontWeight: 600, color: C.fg2, minHeight: 38 }}>{c.label}</div>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginTop: "auto" }}><span style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 44, lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>{c.v}</span><span style={{ fontSize: 13, color: C.mute }}>з 100</span></div>
                    <div style={{ height: 4, marginTop: 14, borderRadius: 2, background: C.surface3 }}><div style={{ height: 4, borderRadius: 2, background: scoreColor(c.v), width: `${c.v}%` }} /></div>
                    <div style={{ fontSize: 12.5, fontWeight: 700, marginTop: 10, color: scoreColor(c.v) }}>{statusLabel(c.v)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Chart + PageSpeed */}
          {(history.length >= 2 || ps) && (
            <div className="r360-chartrow">
              {history.length >= 2 ? <ChartBlock points={history} /> : <div />}
              {ps && <PsiBlock ps={ps} />}
            </div>
          )}

          {/* Serpstat live scorecards */}
          {extras?.info && <SerpstatScorecards info={extras.info} />}

          {/* Distribution + competitors + keywords */}
          {extras && (extras.keywords?.length > 0 || extras.competitors?.length > 0) && (
            <>
              <div className="r360-distrow">
                <div style={{ display: "grid", gap: 16 }}>
                  {extras.keywords?.length > 0 && <PositionDist keywords={extras.keywords} />}
                  {extras.competitors?.length > 0 && <CompetitorsBlock competitors={extras.competitors} ownVisible={extras.info?.visible || 0} />}
                </div>
                {extras.keywords?.length > 0 ? <KeywordsTable keywords={extras.keywords} /> : <div />}
              </div>
            </>
          )}

          {/* Attention */}
          {attention.length > 0 && <Attention items={attention} criticalCount={critical.length} />}

          {/* Wins */}
          {wins.length > 0 && <Wins wins={wins} />}

          {/* CTA */}
          <div className="r360-cta" style={{ marginTop: 96, padding: 48, background: C.accent, color: C.accentInk, borderRadius: 26 }}>
            <div>
              <h3 style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 40, lineHeight: 1.1, letterSpacing: "-0.02em", margin: 0 }}>Потрібна допомога з виправленням?</h3>
              <p style={{ fontSize: 16.5, lineHeight: "26px", margin: "16px 0 0", fontWeight: 500, maxWidth: "58ch" }}>Spalah — інструмент який допомагає сайтам влетіти в ТОП. Розробка Svitlo Agency: багаторічна SEO-експертиза плюс AI = ми робимо те, що раніше було неможливим. Якщо хочете щоб ми взялись за ваш сайт — напишіть нам.</p>
            </div>
            <div style={{ display: "grid", gap: 10 }}>
              <a href="https://svitlo.agency" target="_blank" rel="noopener" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 60, borderRadius: 14, background: C.card, color: C.fg, fontWeight: 700, fontSize: 17, textDecoration: "none" }}>Звернутись у Svitlo</a>
              <a href="https://spalah.app" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 60, borderRadius: 14, border: `2px solid ${C.accentInk}`, color: C.accentInk, fontWeight: 700, fontSize: 17, textDecoration: "none" }}>Перейти на Spalah →</a>
            </div>
          </div>

          {/* Footer */}
          <footer className="r360-foot">
            <span>Згенеровано на spalah.app — розробка Svitlo Agency.</span>
            <span className="r360-hide-m">Потрібна професійна допомога? <a href="https://svitlo.agency" target="_blank" rel="noopener" className="r360-link" style={{ color: C.accent, fontWeight: 700, textDecoration: "none" }}>Напишіть нам</a> — ми робимо SEO для бізнесу.</span>
          </footer>

          {/* Mobile sticky bar */}
          <div className="r360-mobbar">
            <a href="https://svitlo.agency" target="_blank" rel="noopener" style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 48, borderRadius: 13, background: C.accent, color: C.accentInk, fontWeight: 700, fontSize: 15, textDecoration: "none" }}>Виправити з Svitlo</a>
            <button onClick={() => window.print()} style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 48, padding: "0 16px", borderRadius: 13, background: C.surface2, color: C.fg, fontWeight: 700, fontSize: 14, border: 0, cursor: "pointer", fontFamily: SANS }}>PDF</button>
          </div>
        </div>
      </div>
    </Shell>
  );
}

// AI-висновок: розбиваємо на абзаци, перший показуємо, решту — під «Читати далі».
function AiNarrative({ text }) {
  const [open, setOpen] = useState(false);
  const clean = (text || "").trim();
  if (!clean) return <p style={{ fontSize: 16, lineHeight: "27px", margin: "16px 0 0", color: C.fg2 }}>—</p>;

  // 1) абзаци по порожньому рядку; 2) по одинарному; 3) по реченнях.
  let blocks = clean.split(/\n{2,}/).map(s => s.trim()).filter(Boolean);
  if (blocks.length < 2) blocks = clean.split(/\n/).map(s => s.trim()).filter(Boolean);
  if (blocks.length < 2) {
    const sents = clean.match(/[^.!?…]+[.!?…]+(?:\s|$)/g);
    if (sents && sents.length > 3) {
      blocks = [sents.slice(0, 3).join("").trim(), sents.slice(3).join("").trim()].filter(Boolean);
    }
  }
  const hasMore = blocks.length > 1;
  const shown = open ? blocks : blocks.slice(0, 1);

  return (
    <div>
      <div style={{ position: "relative" }}>
        {shown.map((b, i) => {
          const m = b.match(/^\s*(\d+)[.)]\s+(.*)$/s); // нумерований пункт → підсвічуємо номер
          if (m) {
            return (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "26px minmax(0,1fr)", gap: 12, margin: i === 0 ? "16px 0 0" : "12px 0 0" }}>
                <span style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 18, lineHeight: "27px", color: C.accent }}>{m[1]}</span>
                <p style={{ fontSize: 16, lineHeight: "27px", margin: 0, color: C.fg2 }}>{m[2]}</p>
              </div>
            );
          }
          return <p key={i} style={{ fontSize: 16, lineHeight: "27px", margin: i === 0 ? "16px 0 0" : "12px 0 0", color: C.fg2 }}>{b}</p>;
        })}
        {hasMore && !open && (
          <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, height: 48, background: `linear-gradient(180deg, rgba(27,27,28,0), ${C.surface})`, pointerEvents: "none" }} />
        )}
      </div>
      {hasMore && (
        <button onClick={() => setOpen(o => !o)} style={{ marginTop: 10, padding: 0, background: "none", border: 0, color: C.accent, font: `700 14px ${SANS}`, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
          {open ? "Згорнути" : "Читати далі"}
          <span style={{ display: "inline-block", transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▾</span>
        </button>
      )}
    </div>
  );
}

function AnimatedNumber({ value, style, className }) {
  const [v, setV] = useState(0);
  useEffect(() => {
    let raf, s;
    const tick = (t) => {
      if (!s) s = t;
      const p = Math.min(1, (t - s) / 1400);
      setV(Math.round((value || 0) * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return <span className={className} style={style}>{v}</span>;
}

// ─── Interactive chart ───
function ChartBlock({ points }) {
  const svgRef = useRef(null);
  const [hov, setHov] = useState(-1);
  const n = points.length - 1;
  const vis = points.map(p => Number(p.visibility) || 0);
  const keys = points.map(p => Number(p.keywords) || 0);
  const traf = points.map(p => Number(p.traff) || 0);
  const range = (arr) => { const lo = Math.min(...arr), hi = Math.max(...arr); const pad = (hi - lo) * 0.12 || 1; return [lo - pad, hi + pad]; };
  const [vl, vh] = range(vis), [kl, kh] = range(keys), [tl, th] = range(traf);
  const Y = (val, lo, hi) => 220 - (val - lo) / (hi - lo || 1) * 190;
  const X = (i) => (i / (n || 1)) * 1000;
  const path = (arr, lo, hi) => "M" + arr.map((v, i) => `${X(i).toFixed(1)} ${Y(v, lo, hi).toFixed(1)}`).join(" L");
  const area = (arr, lo, hi) => `${path(arr, lo, hi)} L1000 220 L0 220 Z`;

  const onMove = (e) => {
    const svg = svgRef.current; if (!svg) return;
    const r = svg.getBoundingClientRect();
    const i = Math.max(0, Math.min(n, Math.round(((e.clientX - r.left) / r.width) * n)));
    setHov(i);
  };
  const hi = hov >= 0 ? hov : n;
  const latest = points[n] || {}, oldest = points[0] || {};
  const delta = oldest.visibility ? Math.round(((latest.visibility - oldest.visibility) / oldest.visibility) * 100) : 0;
  const peak = points.reduce((a, b) => (b.visibility > a.visibility ? b : a), points[0]);
  const hpPct = (hi / (n || 1)) * 100;

  const kpis = [
    { label: "Видимість зараз", v: fmtf(latest.visibility), c: C.accent },
    { label: "Пік за період", v: fmtf(peak?.visibility), sub: peak?.date, c: C.pos },
    { label: "Δ за період", v: `${delta >= 0 ? "+" : ""}${delta}%`, c: delta >= 0 ? C.pos : C.neg },
    { label: "Ключі зараз", v: fmt(latest.keywords), c: C.fg },
    latest.aio_citations > 0 ? { label: "AIO згадок", v: fmt(latest.aio_citations), sub: `з ${fmt(latest.aio_keywords)}`, c: C.accent } : null,
  ].filter(Boolean);

  const tickEvery = Math.ceil(points.length / 7);
  const ticks = points.filter((_, i) => i % tickEvery === 0 || i === n);

  return (
    <div style={{ padding: 28, background: C.surface, borderRadius: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 16, flexWrap: "wrap" }}>
        <div><div style={{ fontWeight: 800, fontSize: 18 }}>Динаміка в пошуку · Serpstat</div><div style={{ fontSize: 13.5, color: C.mute, marginTop: 4 }}>Наведіть на графік, щоб побачити цифри за місяць · g_ua · {points.length} міс.</div></div>
        <div className="r360-hide-m" style={{ display: "flex", gap: 16, fontSize: 13, color: C.mute, flex: "none" }}>
          <span style={{ display: "flex", alignItems: "center", gap: 7 }}><span style={{ width: 14, height: 3, borderRadius: 2, background: C.accent }} />Видимість</span>
          <span style={{ display: "flex", alignItems: "center", gap: 7 }}><span style={{ width: 14, height: 3, borderRadius: 2, background: C.pos }} />Ключі в ТОП-100</span>
          <span style={{ display: "flex", alignItems: "center", gap: 7 }}><span style={{ width: 14, height: 3, borderRadius: 2, background: C.mute }} />Прогноз трафіку</span>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${kpis.length}, minmax(0,1fr))`, gap: 16, marginTop: 24 }}>
        {kpis.map((k, i) => (
          <div key={i}>
            <div style={{ fontSize: 12.5, color: C.mute }}>{k.label}</div>
            <div style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 22, lineHeight: 1.1, marginTop: 8, color: k.c, whiteSpace: "nowrap" }}>{k.v}</div>
            {k.sub && <div style={{ fontSize: 12, color: C.mute, marginTop: 4 }}>{k.sub}</div>}
          </div>
        ))}
      </div>
      <div style={{ position: "relative", marginTop: 24, cursor: "crosshair", touchAction: "pan-y" }}
        onPointerMove={onMove} onPointerDown={onMove} onPointerLeave={() => setHov(-1)}>
        <svg ref={svgRef} viewBox="0 0 1000 240" preserveAspectRatio="none" width="100%" height="240" style={{ display: "block" }}>
          {[20, 120, 220].map(y => <line key={y} x1="0" y1={y} x2="1000" y2={y} style={{ stroke: C.surface3 }} vectorEffect="non-scaling-stroke" />)}
          <path d={area(vis, vl, vh)} style={{ fill: C.accent, fillOpacity: 0.12 }} />
          <path d={path(traf, tl, th)} style={{ fill: "none", stroke: C.mute, strokeWidth: 1.5 }} vectorEffect="non-scaling-stroke" />
          <path d={path(keys, kl, kh)} style={{ fill: "none", stroke: C.pos, strokeWidth: 2 }} vectorEffect="non-scaling-stroke" />
          <path d={path(vis, vl, vh)} style={{ fill: "none", stroke: C.accent, strokeWidth: 2.5 }} vectorEffect="non-scaling-stroke" />
        </svg>
        {hov >= 0 && (<>
          <div style={{ position: "absolute", top: 0, bottom: 0, width: 1, background: C.fg, opacity: 0.35, pointerEvents: "none", left: `${hpPct}%` }} />
          <div style={{ position: "absolute", top: `${(Y(vis[hi], vl, vh) / 240) * 240}px`, width: 10, height: 10, margin: "-5px 0 0 -5px", borderRadius: "50%", background: C.accent, boxShadow: `0 0 0 3px ${C.surface}`, pointerEvents: "none", left: `${hpPct}%` }} />
          <div style={{ position: "absolute", top: 8, transform: "translateX(-50%)", minWidth: 190, padding: "12px 14px", background: C.surface3, border: `1px solid ${C.line2}`, borderRadius: 12, pointerEvents: "none", left: `${Math.min(88, Math.max(12, hpPct))}%` }}>
            <div style={{ font: `500 12px ${MONO}`, color: C.mute }}>{points[hi].date}</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "4px 14px", marginTop: 8, fontSize: 13 }}>
              <span style={{ color: C.accent }}>Видимість</span><span style={{ fontWeight: 700 }}>{fmtf(points[hi].visibility)}</span>
              <span style={{ color: C.pos }}>Ключі</span><span style={{ fontWeight: 700 }}>{fmt(points[hi].keywords)}</span>
              <span style={{ color: C.mute }}>Трафік</span><span style={{ fontWeight: 700 }}>{fmt(points[hi].traff)}</span>
            </div>
          </div>
        </>)}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, font: `500 12px ${MONO}`, color: C.mute2 }}>
        {ticks.map((p, i) => <span key={i}>{String(p.date || "").slice(5).replace("-", ".")}</span>)}
      </div>
    </div>
  );
}

function PsiBlock({ ps }) {
  const gauges = [
    { label: "Performance", v: ps.performance },
    { label: "Accessibility", v: ps.accessibility },
    { label: "Best Practices", v: ps.bestPractices },
    { label: "SEO", v: ps.seo },
  ].filter(g => g.v != null);
  const vitalColor = (k, dv) => {
    const num = parseFloat(String(dv).replace(",", "."));
    if (isNaN(num)) return C.fg;
    if (k === "LCP") return num <= 2.5 ? C.pos : num <= 4 ? C.warn : C.neg;
    if (k === "FCP") return num <= 1.8 ? C.pos : num <= 3 ? C.warn : C.neg;
    if (k === "CLS") return num <= 0.1 ? C.pos : num <= 0.25 ? C.warn : C.neg;
    if (k === "TBT") return num <= 200 ? C.pos : num <= 600 ? C.warn : C.neg;
    return C.fg;
  };
  const vitals = [
    ps.lcp ? { k: "LCP", v: ps.lcp } : null,
    ps.cls ? { k: "CLS", v: ps.cls } : null,
    ps.fcp ? { k: "FCP", v: ps.fcp } : null,
    ps.tbt ? { k: "TBT", v: ps.tbt } : null,
  ].filter(Boolean);
  return (
    <div style={{ padding: 28, background: C.surface, borderRadius: 24 }}>
      <div style={{ fontWeight: 800, fontSize: 18 }}>PageSpeed Insights</div>
      <div style={{ fontSize: 13.5, color: C.mute, marginTop: 4 }}>мобільна версія</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px 12px", marginTop: 24 }}>
        {gauges.map((g, i) => {
          const col = psiColor(g.v);
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ position: "relative", width: 64, height: 64, flex: "none" }}>
                <svg viewBox="0 0 36 36" width="64" height="64" style={{ display: "block", transform: "rotate(-90deg)" }}>
                  <circle cx="18" cy="18" r="15.5" style={{ fill: "none", stroke: C.surface3, strokeWidth: 3 }} />
                  <circle cx="18" cy="18" r="15.5" pathLength="100" style={{ fill: "none", stroke: col, strokeWidth: 3, strokeLinecap: "round", strokeDasharray: `${g.v} 100` }} />
                </svg>
                <span style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", fontFamily: DISPLAY, fontWeight: 700, fontSize: 17, color: col }}>{g.v}</span>
              </div>
              <span style={{ fontSize: 13.5, fontWeight: 600, lineHeight: "18px" }}>{g.label}</span>
            </div>
          );
        })}
      </div>
      {vitals.length > 0 && (
        <div style={{ display: "grid", gap: 8, marginTop: 24 }}>
          {vitals.map((v, i) => {
            const col = vitalColor(v.k, v.v);
            return (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "11px 14px", background: C.surface2, borderRadius: 12, font: `500 14px ${MONO}` }}>
                <span style={{ color: C.mute }}>{v.k}</span>
                <span style={{ display: "flex", alignItems: "center", gap: 8, color: col }}>{v.v}<span style={{ width: 7, height: 7, borderRadius: "50%", background: col }} /></span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function SerpstatScorecards({ info }) {
  const cards = [
    { label: "Видимість", v: fmtf(info.visible), sub: deltaSub(info.visible_dynamic), c: trendColor(info.visible_dynamic) },
    { label: "Ключів у Google", v: fmt(info.keywords), sub: "", c: C.fg3 },
    { label: "Трафік (оцінка)", v: fmt(info.traff), sub: deltaSub(info.traff_dynamic, true), c: trendColor(info.traff_dynamic) },
    info.traffic_ai > 0 ? { label: "AI-трафік", v: fmt(info.traffic_ai), sub: "", c: C.accent } : null,
    info.aio_citations > 0 ? { label: "AIO-цитувань", v: fmt(info.aio_citations), sub: `з ${fmt(info.aio_keywords)} ключів`, c: C.accent } : null,
    { label: "Ключі ↑ / ↓", v: `${fmt(info.rised_keywords)} / ${fmt(info.down_keywords)}`, sub: "", c: info.rised_keywords >= info.down_keywords ? C.pos : C.neg },
    { label: "Нові / втрачені", v: `+${fmt(info.new_keywords)} / −${fmt(info.out_keywords)}`, sub: "", c: info.new_keywords >= info.out_keywords ? C.pos : C.neg },
  ].filter(Boolean);
  return (
    <div className="r360-serp-wrap" style={{ marginTop: 16, background: C.surface, borderRadius: 24 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}><span style={{ width: 8, height: 8, borderRadius: "50%", background: C.pos, animation: "r360-pulse 1.6s ease-in-out infinite" }} /><span style={{ fontWeight: 800, fontSize: 18 }}>Дані з Serpstat</span><span style={{ fontSize: 13.5, color: C.mute }}>· жива аналітика видимості</span></div>
      <div className="r360-serp7">
        {cards.map((s, i) => (
          <div key={i} style={{ padding: 16, background: C.surface2, borderRadius: 16, minWidth: 0 }}>
            <div style={{ fontSize: 12, color: C.mute, lineHeight: 1.3 }}>{s.label}</div>
            <div className="r360-serp-v" style={{ fontFamily: DISPLAY, fontWeight: 700, lineHeight: 1.15, marginTop: 8, wordBreak: "break-word" }}>{s.v}</div>
            {s.sub && <div style={{ fontSize: 12, fontWeight: 700, marginTop: 6, color: s.c }}>{s.sub}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
function trendColor(d) { return Number(d) > 0 ? C.pos : Number(d) < 0 ? C.neg : C.mute; }
function deltaSub(d, isInt) {
  const n = Number(d || 0);
  if (!n) return "";
  return `${n > 0 ? "▲" : "▼"} ${isInt ? fmt(Math.abs(n)) : fmtf(Math.abs(n))}`;
}

function PositionDist({ keywords }) {
  const buckets = [
    { label: "ТОП 1-3", min: 1, max: 3, c: C.pos },
    { label: "4-10", min: 4, max: 10, c: C.accent },
    { label: "11-30", min: 11, max: 30, c: C.warn },
    { label: "31+", min: 31, max: 9999, c: C.mute },
  ];
  const data = buckets.map(b => ({ ...b, n: keywords.filter(k => k.pos >= b.min && k.pos <= b.max).length }));
  const total = data.reduce((s, d) => s + d.n, 0) || 1;
  return (
    <div style={{ padding: 24, background: C.surface, borderRadius: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}><span style={{ fontWeight: 800, fontSize: 17 }}>Розподіл позицій</span><span style={{ fontSize: 13, color: C.mute }}>{keywords.length} запитів</span></div>
      <div style={{ fontSize: 13, color: C.mute, marginTop: 4 }}>За ТОП-{keywords.length} запитами (трафік)</div>
      <div style={{ display: "flex", gap: 3, height: 10, marginTop: 18, borderRadius: 5, overflow: "hidden" }}>
        {data.filter(d => d.n > 0).map((d, i) => <span key={i} style={{ background: d.c, flexGrow: d.n }} />)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0,1fr))", gap: 8, marginTop: 16 }}>
        {data.map((d, i) => (
          <div key={i}><div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: C.mute }}><span style={{ width: 7, height: 7, borderRadius: "50%", background: d.c }} />{d.label}</div><div style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 24, marginTop: 6 }}>{d.n}</div></div>
        ))}
      </div>
    </div>
  );
}

function CompetitorsBlock({ competitors, ownVisible }) {
  const own = ownVisible || 0;
  const rows = [{ name: "Ваш сайт", v: own, own: true }, ...competitors.map(c => ({ name: c.domain, v: c.visible || 0, common: c.common }))];
  const max = Math.max(...rows.map(r => r.v), 0.1);
  const aheadCount = competitors.filter(c => (c.visible || 0) > own).length;
  return (
    <div style={{ padding: 24, background: C.surface, borderRadius: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontWeight: 800, fontSize: 17 }}>Конкуренти за видимістю</span>
        {aheadCount > 0 && <span style={{ fontSize: 12, fontWeight: 700, color: C.warn }}>▲ {aheadCount} попереду вас</span>}
      </div>
      <div style={{ fontSize: 13, color: C.mute, marginTop: 4 }}>Serpstat visibility index · g_ua</div>
      <div style={{ display: "grid", gap: 12, marginTop: 18 }}>
        {rows.map((c, i) => {
          const ahead = !c.own && c.v > own;         // конкурент видимістю вищий за ваш сайт
          const barColor = c.own ? C.accent : ahead ? C.warn : C.mute;
          const numColor = c.own ? C.accent : ahead ? C.warn : C.fg3;
          const h = ahead || c.own ? 5 : 4;
          return (
            <div key={i} title={c.common ? `Спільних ключів: ${fmt(c.common)}${ahead ? " · видимість вища за вашу" : ""}` : ""}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 12, fontSize: 14, alignItems: "center" }}>
                <span style={{ fontWeight: c.own ? 800 : ahead ? 700 : 500, color: c.own || ahead ? C.fg : C.fg2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                  {ahead && <span style={{ color: C.warn, fontSize: 11, flex: "none" }}>▲</span>}
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</span>
                </span>
                <span style={{ font: `600 13.5px ${MONO}`, color: numColor, whiteSpace: "nowrap" }}>{fmtf(c.v)}</span>
              </div>
              <div style={{ height: h, marginTop: 6, borderRadius: 3, background: C.surface3 }}>
                <div style={{ height: h, borderRadius: 3, background: barColor, width: `${Math.max(3, (c.v / max) * 100)}%`, minWidth: 3, boxShadow: ahead ? `0 0 8px ${C.warn}aa` : c.own ? `0 0 8px ${C.accent}99` : "none" }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function KeywordsTable({ keywords }) {
  const [sort, setSort] = useState("traff");
  const [dir, setDir] = useState(-1);
  const cols = [
    { key: "kw", label: "Запит", align: "left" },
    { key: "pos", label: "Поз.", align: "right" },
    { key: "vol", label: "Обсяг", align: "right" },
    { key: "traff", label: "Трафік", align: "right" },
    { key: "diff", label: "KD", align: "right" },
  ];
  const sorted = [...keywords].sort((a, b) => {
    const av = a[sort], bv = b[sort];
    const cmp = typeof av === "string" ? String(av).localeCompare(String(bv)) : (av - bv);
    return dir * cmp;
  });
  const onSort = (k) => { if (sort === k) setDir(d => -d); else { setSort(k); setDir(-1); } };
  const posColor = (p) => p <= 3 ? C.pos : p <= 10 ? C.accent : p <= 30 ? C.warn : C.mute;
  const GRID = "minmax(0,1fr) 92px 92px 92px 54px";
  return (
    <div style={{ padding: 24, background: C.surface, borderRadius: 24, overflow: "hidden" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}><span style={{ fontWeight: 800, fontSize: 17 }}>Топ запитів за трафіком</span><span style={{ fontSize: 13, color: C.mute }}>Клік на заголовок — сортування · {keywords.length} запитів</span></div>
      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: 520 }}>
          <div style={{ display: "grid", gridTemplateColumns: GRID, gap: 12, padding: "14px 14px 10px", marginTop: 12, borderBottom: `1px solid ${C.surface3}` }}>
            {cols.map(h => (
              <button key={h.key} onClick={() => onSort(h.key)} style={{ padding: 0, background: "none", border: 0, textAlign: h.align, color: sort === h.key ? C.accent : C.mute, font: `700 12px ${SANS}`, letterSpacing: "0.06em", textTransform: "uppercase", cursor: "pointer" }}>{h.label} {sort === h.key ? (dir < 0 ? "▼" : "▲") : ""}</button>
            ))}
          </div>
          <div>
            {sorted.map((q, i) => (
              <div key={i} className="r360-irow" style={{ display: "grid", gridTemplateColumns: GRID, gap: 12, alignItems: "center", padding: "11px 14px", borderRadius: 10, fontSize: 14.5 }}>
                <span style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 600, overflow: "hidden" }}><span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{q.kw}</span>{q.aio && <span style={{ padding: "2px 7px", borderRadius: 6, background: "#12322b", color: C.pos, font: `700 10.5px ${SANS}`, whiteSpace: "nowrap" }}>AI</span>}</span>
                <span style={{ textAlign: "right", font: `500 14px ${MONO}` }}><span style={{ color: posColor(q.pos) }}>{q.pos}</span> {q.dyn !== 0 && <span style={{ color: q.dyn > 0 ? C.pos : C.neg, fontSize: 12 }}>{q.dyn > 0 ? "▲" : "▼"}{Math.abs(q.dyn)}</span>}</span>
                <span style={{ textAlign: "right", font: `500 14px ${MONO}`, color: C.fg3 }}>{fmt(q.vol)}</span>
                <span style={{ textAlign: "right", font: `500 14px ${MONO}` }}>{fmt(q.traff)}</span>
                <span style={{ textAlign: "right", font: `500 14px ${MONO}`, color: C.fg3 }}>{q.diff || "—"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Attention({ items, criticalCount }) {
  const [filter, setFilter] = useState("all");
  const [open, setOpen] = useState({ 0: true });
  const [expanded, setExpanded] = useState(false);

  const catCounts = {};
  items.forEach(f => { const l = CAT_LABEL[f.category] || f.category; catCounts[l] = (catCounts[l] || 0) + 1; });
  const chips = [{ label: "Всі", key: "all", n: items.length }, ...Object.entries(catCounts).map(([label, n]) => ({ label, key: label, n }))];

  const filtered = filter === "all" ? items : items.filter(f => (CAT_LABEL[f.category] || f.category) === filter);
  const shown = expanded ? filtered : filtered.slice(0, 6);

  return (
    <div className="r360-split" style={{ marginTop: 80 }}>
      <div style={{ position: "sticky", top: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ width: 28, height: 28, borderRadius: 9, background: C.accent, color: C.accentInk, display: "grid", placeItems: "center", fontWeight: 800 }}>!</span><span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", color: C.accent }}>УВАГИ · {items.length}{criticalCount > 0 ? ` · ${criticalCount} крит.` : ""}</span></div>
        <h3 style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 32, lineHeight: 1.12, letterSpacing: "-0.02em", margin: "14px 0 0" }}>Варто покращити</h3>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 22 }}>
          {chips.map((ch) => {
            const on = filter === ch.key;
            return <button key={ch.key} onClick={() => { setFilter(ch.key); setExpanded(true); }} style={{ padding: "8px 13px", borderRadius: 999, border: `1px solid ${on ? C.accent : C.line}`, background: on ? "rgba(255,106,43,.14)" : "transparent", color: on ? C.accent : C.fg2, font: `700 13px ${SANS}`, cursor: "pointer" }}>{ch.label} <span style={{ opacity: 0.6 }}>{ch.n}</span></button>;
          })}
        </div>
        {filtered.length > 6 && (
          <button onClick={() => setExpanded(e => !e)} style={{ marginTop: 20, padding: 0, background: "none", border: 0, color: C.mute, font: `700 14px ${SANS}`, cursor: "pointer" }}>{expanded ? "Згорнути" : `Показати всі ${filtered.length}`}</button>
        )}
      </div>
      <div style={{ display: "grid", gap: 8 }}>
        {shown.map((f, idx) => {
          const isOpen = !!open[idx];
          const isCrit = f.severity === "critical";
          const rawRec = f.recommendation || "";
          const hasSvitlo = SV_SUFFIX_RE.test(rawRec);
          const rec = rawRec.replace(SV_SUFFIX_RE, "").trim();
          return (
            <div key={idx} style={{ background: C.surface, borderRadius: 18 }}>
              <button onClick={() => setOpen(o => ({ ...o, [idx]: !o[idx] }))} aria-expanded={isOpen} style={{ width: "100%", display: "grid", gridTemplateColumns: "28px minmax(0,1fr) auto 28px", alignItems: "center", gap: 14, padding: "18px 20px", background: "transparent", border: 0, color: C.fg, textAlign: "left", cursor: "pointer" }}>
                <span style={{ width: 24, height: 24, borderRadius: 8, background: isCrit ? C.neg : C.surface3, color: isCrit ? C.accentInk : C.accent, display: "grid", placeItems: "center", fontWeight: 800, fontSize: 13 }}>!</span>
                <span style={{ font: `700 16px/22px ${SANS}` }}>{f.title}</span>
                <span style={{ padding: "4px 10px", borderRadius: 999, background: C.surface2, color: C.mute, font: `600 12px ${SANS}`, whiteSpace: "nowrap" }}>{CAT_LABEL[f.category] || f.category}</span>
                <span style={{ width: 28, height: 28, borderRadius: 9, background: C.surface2, color: C.mute, display: "grid", placeItems: "center", fontSize: 17, transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▾</span>
              </button>
              {isOpen && (
                <div style={{ animation: "r360-drop 300ms ease both", padding: "0 20px 20px 62px" }}>
                  {f.description && <p style={{ margin: 0, fontSize: 15, lineHeight: "24px", color: C.fg3, maxWidth: "72ch" }}>{f.description}</p>}
                  {rec && (
                    <div style={{ marginTop: 14, padding: "14px 16px", background: C.surface2, borderRadius: 14 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.1em", color: C.pos }}>РЕКОМЕНДАЦІЯ</div>
                      <p style={{ margin: "6px 0 0", fontSize: 14.5, lineHeight: "23px", color: C.fg }}>{rec}</p>
                      {hasSvitlo && <a href="https://svitlo.agency" target="_blank" rel="noopener" className="r360-link" style={{ display: "inline-flex", marginTop: 12, fontSize: 14, fontWeight: 700, color: C.accent, textDecoration: "none" }}>Не знаєте як? Svitlo Agency зробить під ключ →</a>}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Wins({ wins }) {
  const [open, setOpen] = useState(false);
  const shown = open ? wins : wins.slice(0, 8);
  return (
    <div className="r360-split" style={{ marginTop: 56 }}>
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ width: 28, height: 28, borderRadius: 9, background: C.pos, color: C.posInk, display: "grid", placeItems: "center", fontWeight: 800 }}>✓</span><span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", color: C.pos }}>ПЕРЕМОГИ · {wins.length}</span></div>
        <h3 style={{ fontFamily: DISPLAY, fontWeight: 600, fontSize: 32, lineHeight: 1.12, letterSpacing: "-0.02em", margin: "14px 0 0" }}>Що ви робите добре</h3>
        {wins.length > 8 && <button onClick={() => setOpen(o => !o)} style={{ marginTop: 20, padding: 0, background: "none", border: 0, color: C.mute, font: `700 14px ${SANS}`, cursor: "pointer" }}>{open ? "Згорнути" : `Показати всі ${wins.length}`}</button>}
      </div>
      <div className="r360-wins">
        {shown.map((g, i) => (
          <div key={i} style={{ animation: "r360-drop 300ms ease both", display: "flex", gap: 12, alignItems: "center", padding: "16px 18px", background: C.surface, borderRadius: 16, fontWeight: 600, fontSize: 15 }}><span style={{ color: C.pos, flex: "none" }}>✓</span>{g.title}</div>
        ))}
      </div>
    </div>
  );
}
